<template>
    <d-container fluid class="main-content-container px-4">
        <!-- Page Header -->
        <div class="page-header row no-gutters py-4">
            <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
                <span class="text-uppercase page-subtitle">Minibus</span>
                <h3 class="page-title">Gérer les minibus</h3>
            </div>
        </div>
        <d-row>
            <d-col lg="10" xl="9" class="mx-auto mt-1">
                <d-card class="card-small edit-user-details mb-4">
                    <d-card-header class="p-0">
                        <!-- User Details - Background -->
                        <div class="edit-user-details__bg">
                        <img src="@/assets/images/user-profile/up-user-details-background.jpg"
                            alt="User Details Background Image">
                        </div>
                    </d-card-header>
                    <d-card-body class="p-0">
                        <div class="clearfix">
                            <div class="border-0 mt-auto mx-4 pt-2">
                                <d-tabs content-class="mt-3 tab-choice">
                                    <d-tab v-if="edit" title="Modifier les détails du minibus" active>
                                        <d-form class="py-4">
                                            <d-form-row class="mx-4">
                                                <d-col class="mb-3">
                                                    <d-form-text tag="h6" class="m-0">Modifier Un Minibus</d-form-text>
                                                </d-col>
                                            </d-form-row>
                                            <d-form-row class="mx-4">
                                                <d-col md="6" class="form-group">
                                                    <label for="mame">Nom</label>
                                                    <d-input type="text" id="name" v-model="model.name" :state="errors['name'] === undefined ? null : false"/>
                                                    <errors :errors="errors" field="name"/>
                                                </d-col>
                                                <d-col md="6" class="form-group">
                                                    <label for="available">Disponibilité</label>
                                                    <d-col class="d-flex">
                                                        <span>Ce minibus est-il disponible ?</span>
                                                        <d-checkbox id="available" class="ml-auto my-auto" v-model="model.available" toggle/>
                                                    </d-col>
                                                </d-col>
                                            </d-form-row> 
                                        </d-form>
                                        <d-div class="d-flex justify-content-around">
                                            <div class="col">
                                                <d-button size="sm" class="btn-accent float-right  d-table" @click="saveEditMinibus">
                                                    {{ $t('global.save') }}
                                                </d-button>
                                                <d-button size="sm" class="btn-accent float-right  d-table mr-5" @click="backToList">
                                                    Retour à la liste
                                                </d-button>
                                            </div>
                                        </d-div>   
                                    </d-tab>
                                    <d-tab v-else title="Liste Des Minibus" active>
                                        <table class="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th>Nom</th>
                                                    <th>Disponibilité</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <spinner-dot v-if="loading" />
                                                <tr v-for="(bus, idx) in minibusList" :key="idx">
                                                    <td>{{bus.name}}</td>
                                                    <td v-if="bus.available"><p class="available">Disponible</p></td>
                                                    <td v-else><p class="notAvailable">Indisponible</p></td>
                                                    <td>
                                                        <button class="btn btn-accent " @click="editMinibus(bus)">Éditer</button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </d-tab>

                                    <d-tab title="Ajouter Minibus">
                                        <d-form class="py-4">
                                            <d-form-row class="mx-4">
                                                <d-col class="mb-3">
                                                    <d-form-text tag="h6" class="m-0">Ajouter Un Minibus</d-form-text>
                                                </d-col>
                                            </d-form-row>
                                            <d-form-row class="mx-4">
                                                <d-col md="6" class="form-group">
                                                    <label for="mame">Nom</label>
                                                    <d-input type="text" id="name" v-model="model.name" :state="errors['name'] === undefined ? null : false"/>
                                                    <errors :errors="errors" field="name"/>
                                                </d-col>
                                                <d-col md="6" class="form-group">
                                                    <label for="available">Disponibilité</label>
                                                    <d-col class="d-flex">
                                                        <span>Ce minibus est-il disponible ?</span>
                                                        <d-checkbox id="available" class="ml-auto my-auto" v-model="model.available" toggle/>
                                                    </d-col>
                                                </d-col>
                                            </d-form-row> 
                                        </d-form>
                                        <d-div class="d-flex justify-content-around">
                                            <div class="col">
                                                <d-button size="sm" class="btn-accent float-right  d-table" @click="saveMinibus">
                                                    {{ $t('global.save') }}
                                                </d-button>
                                            </div>
                                        </d-div>                                                                                 
                                    </d-tab>
                                </d-tabs>
                            </div>
                        </div>
                    </d-card-body>
                </d-card>
            </d-col>
        </d-row>
    </d-container>
</template>

<script>
import SpinnerDot from "../../components/layout/Loading/spinner-dot";
import ErrorsHelper from '../../helper/ErrorsHelper';


export default {
    name: "minibus-management",
    components: {
        SpinnerDot
    },
    data() {
        return {
            loading: true,
            minibusList: [],
            requiredFields: ['name'],
            edit: false,
            model: {
                name: "",
                available: true,
                reference: "",
                reservation: []
            },
            errors: {}
        };
    },
    mounted() {
        this.$services.minibusManagement.findAll().then((res) => {
            this.minibusList = res.data.data;
            this.loading = false;
            })
    },
    methods: {
        saveMinibus() {
            if (ErrorsHelper.checkErrors(this.requiredFields, this.model, this.errors)) {

                    this.$services.minibusManagement.create(this.model)
                    .then(() => {
                        this.$router.go();
                        this.$miniToastr.success("Minibus ajouté avec succès"); 
                        })
                    .catch((e) => {
                        this.$miniToastr.error("Il y a eu une erreur lors de l'ajout du minibus");
                    }
                    )
            }
        },

        editMinibus(minibus) {
            this.edit = true;
            this.model = {
                name: minibus.name,
                available: minibus.available,
                reference: minibus.reference,
                reservation: minibus.reservation
            }
        },

        saveEditMinibus() {
            if (ErrorsHelper.checkErrors(this.requiredFields, this.model, this.errors)) {

                    this.$services.minibusManagement.update(this.model)
                    .then(() => {
                        this.$router.go();
                        this.$miniToastr.success("Minibus édité avec succès"); 
                        })
                    .catch((e) => {
                        this.$miniToastr.error("Il y a eu une erreur lors de l'éditer du minibus");
                    }
                    )
            }
        },

        backToList() {
            this.edit = false;
            this.model = {
                name: "",
                available: true,
                reference: ""
            };
        }
    }
}
</script>

<style scoped>
td {
    text-align: start !important;
}
.available {
    display: block;
    border: 1px solid #17c671;
    width: 120px;
    border-radius: 5px;
    padding: 5px 15px;
    font-weight: 700;
    background-color: rgba(23, 198, 113, 0.24);
    color: #17c671;
    margin: auto 0;
    text-align: center;
}

.notAvailable {
    display: block;
    border: 1px solid #c4183c;
    width: 120px;
    border-radius: 5px;
    padding: 5px 15px;
    font-weight: 700;
    background-color: rgba(196, 24, 60, 0.24);
    color: #c4183c;
    margin: auto 0;
    text-align: center;
}
</style>